<section id="team" tabindex="-1"
  [ngClass]="this.router.url === '/home' ? 'date-tabs pt-400 section-padding30' : 'date-tabs pt-400 section-padding30'">
  >
  @if (this.router.url === '/home') {
  <div class="container">
    <div class="row align-items-end justify-content-between">
      <div class="col-lg-6 col-md-9 col-sm-9 col-12">
        <div class="section-title">
          <span>Il nostro team</span>
        </div>
      </div>
    </div>
  </div>

  } @else {
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-lg-6 col-md-9 col-sm-9 col-12">
        <div class="section-title text-center mb-100">
          <h1>Il nostro team</h1>
        </div>
      </div>
    </div>
  </div>
  }
  <div class="team-area pb-150 mt-5">
    <div class="container">
      <div class="row">
        <div class="col-lg-4 col-md-6 col-sm-6" *ngFor="let p of dipendenti; let i = index">
          <div class="single-team mb-30">
            <div class="team-img">
              <img src="resources/img/gallery/{{p.nomeFoto}}" alt="Foto di {{p.denominazione}}" class="img-responsive">
              <div class="team-caption" id="bgTeam">
                <span>{{p.ruolo}}</span>
                <h1><a href="#">{{p.denominazione}}</a></h1>
                <div class="team-social" *ngIf="p.linkInstagram">
                  <ul>
                    <li><a href="{{p.linkInstagram}}"><i class="fab fa-instagram"></i></a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>